import React from 'react';
import {EXTERNAL_LINKS} from '../constants/routes';
import { 
  FaLaptopCode,  
  FaRegHandPointRight,
  FaFire,
  FaLayerGroup,
  FaMapSigns
} from "react-icons/fa";

// ***
// iMetaLab version
// If you ONLY need to update the current version of iMetaLab, simply change this value :)
const version = '2.0.0';

// ***
// Data for iMetaLab Dashboard Homepage Main Title and subtitle
// each property can be empty string or null
export const mainTitle = {
  title: "iMetaLab",
  subTitle: "A metaproteomics data analysis pipeline"
}

// ***
// Data for rendering announcement on Homepage
// can be empty string or null
export const announcement = "";

// ***
// Data for rendering Title, version, sub-title on Homepage
// this specific data structure can be directly plugged into <MessageBoard />
export const messageBoardItems = {
  title: "iMetaLab Data Processing Module",
  version: `version ${version}`,
  subTitle: ""
}

// ***
// Data for rendering the Menu for Demo Sessions & Recent Updates on Homepage
// this specific data structure can be directly plugged into <NavVerticalGroup /> element
export const dataProcessingSupportMenu = [
  {
    key: "demo-session",
    icon: <FaLaptopCode />,
    label: "Demo Sessions",
  },
  {
    key: "recent-updates",
    icon: <FaLayerGroup />,
    label: "Recent Updates",
  },
]

// ***
// Data for rendering Demo Session contents
// this specific data structure can be directly plugged into <InformationCard /> element
export const dataProcessingSessionDemonItems = [
  {
    title: "Explore iMetaLab's Data Processing pipeline using our demonstration session", 
    contents: null
  },
  {
    title: null,
    contents: [
      {
        title: "What is a demonstration session",
        desc: "If you would like to have a quick look at iMetaLab's Data Processing features without setting up your own session, please feel free to check out our demonstration session.",
        icon: <FaRegHandPointRight />
      },
      {
        title: "How to access the demonstration session",
        desc: "Copy and paste the corresponding demonstration session IDs into the session ID input section in \"Create Session\" to view the parameters or the input section in \"View Results\" to view the results.",
        icon: <FaRegHandPointRight />
      },
      {
        title: "Demonstration Session ID for Create Session",
        desc: "metasess_5982077a2bf951.10052915",
        icon: <FaRegHandPointRight />
      },
      {
        title: "Demonstration Session ID for Track Session",
        desc: "metasess_5d76f621b3c132.75040813",
        icon: <FaRegHandPointRight />
      },
    ]
  }
]

// ***
// Data for rendering Recent Updates  contents
// this specific data structure can be directly plugged into <InformationCard /> element
export const dataProcessingCurrentUpdateItems = [
  {
    title: "Current version and recent updates", 
    contents: null
  },
  {
    title: null,
    contents: [
      {
        title: `Version ${version} has arrived!`,
        desc: <div><b>MetaLab {`${version}`}</b> is officially released with the new <i>Open Search</i> feature. Now users are able to choose the workflows based on their specific needs.  The new version can now be downloaded by logging into <b>iMetaLab Account</b>.</div>,
        icon: <FaFire />
      },
      {
        title: "iMetaLab guide & FAQs",
        desc: <div>To learn more about how to use iMetaLab and how to debug common issues, please go to our <a href={EXTERNAL_LINKS.IMETALAB_RESOURCE} target="_blank" rel="noopener noreferrer">iMetaLab Wiki Site</a>.</div>,
        icon: <FaMapSigns />
      },
      
    ]
  }
]